import { ADMIN_PARENT_COMPANY_LIST } from "actions/types";

const initialState = {
  list: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ADMIN_PARENT_COMPANY_LIST:
      return {
        ...initialState,
        list: payload,
      };
    default:
      return state;
  }
}
